// StickyBottomBar — bottom-anchored CTA bar for the capture surface.
//
// Used on the redesigned site / building / room screens so the primary
// action (Continue / Save / Done) stays in thumb reach without
// hijacking the main scroll region. The bar sticks to the viewport
// bottom and applies a cream-coloured fade above the content so the
// list scrolls underneath without an abrupt clip.
//
// Sits inside the page's main scroll container (CaptureLayout's
// `<main>`), with negative side margins so the gradient mask spans
// the full width regardless of the parent's padding. Honours the
// safe-area inset on notched devices via `pb-safe`.

import type { ReactElement, ReactNode } from 'react'

export interface StickyBottomBarProps {
  children: ReactNode
}

export function StickyBottomBar({
  children,
}: StickyBottomBarProps): ReactElement {
  return (
    <div
      data-testid="capture-sticky-bottom-bar"
      className="sticky bottom-0 left-0 right-0 z-10 -mx-4 mt-4 flex gap-2.5 bg-gradient-to-t from-[color:var(--color-cc-cream)] from-30% via-[color:var(--color-cc-cream)] via-80% to-transparent px-4 pb-safe pt-5 sm:-mx-6 sm:px-6"
    >
      {children}
    </div>
  )
}
